var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.fieldsAccessData) ? _c('editComponentOfRMApproval', {
    attrs: {
      "awbnumberObject": _vm.awbnumberObject,
      "fieldsAccessData": _vm.fieldsAccessData,
      "images": _vm.images
    },
    on: {
      "prevPage": _vm.Backinvestigation,
      "updateDetails": _vm.updateData
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a43962bc","hasScoped":true}!./src/views/components/RMApproval/editRMApprovalPending/editRMApprovalPending.component.html
// module id = 622
// module chunks = 1